import { model } from '@zentrains/api';

import { Quelle } from '@/model/quelle.ts';

export function mapToExternalQuelle(quelle: Quelle): model.v3.Quelle {
  switch (quelle) {
    case Quelle.DB_BUSINESS_NAVIGATOR:
      return model.v3.Quelle.QUELLE_DB_BUSINESS_NAVIGATOR;
    case Quelle.DB_NAVIGATOR:
      return model.v3.Quelle.QUELLE_DB_NAVIGATOR;
    case Quelle.RIS_STATIONS:
      return model.v3.Quelle.QUELLE_RIS_STATIONS;
    case Quelle.OEBB:
      return model.v3.Quelle.QUELLE_OEBB;
    case Quelle.SBB:
      return model.v3.Quelle.QUELLE_SBB;
    case Quelle.IRIS:
      return model.v3.Quelle.QUELLE_IRIS;
    case Quelle.MUY_VLAK:
      return model.v3.Quelle.QUELLE_MUY_VLAK;
    case Quelle.NS:
      return model.v3.Quelle.QUELLE_NS;
    case Quelle.PKP:
      return model.v3.Quelle.QUELLE_PKP;
    case Quelle.SNCF_CONNECT:
      return model.v3.Quelle.QUELLE_SNCF_CONNECT;
    case Quelle.ENTUR:
      return model.v3.Quelle.QUELLE_ENTUR;
    case Quelle.UNBEKANNT:
    default:
      return model.v3.Quelle.UNRECOGNIZED;
  }
}
